import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import StoreButtons from './StoreButtons';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const isOwnerArea = location.pathname.startsWith('/ow-owner') || location.pathname.startsWith('/restaurant');
  const isOwnerRoot = location.pathname === '/ow-owner';

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const closeMobileMenu = () => setMobileMenuOpen(false);
  const isActive = (path) => location.pathname === path ? 'active' : '';

  const handleLogout = () => {
    closeMobileMenu();
    logout();
    navigate('/ow-owner');
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={closeMobileMenu}>
          <img src="/images/ow-client-logo.png" alt="OW Logo" className="logo-img" />
          <span className="logo-text">OW Client</span>
        </Link>

        <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
          {!isOwnerArea && (
            <a href="/#how-it-works" className="nav-link" onClick={closeMobileMenu}>
              Client App - How It Works
            </a>
          )}
          {!isOwnerArea && (
            <Link to="/ow-owner" className="nav-link" onClick={closeMobileMenu}>
              Restaurant App - How It Works
            </Link>
          )}
          {!isOwnerArea && (
            <Link to="/guide" className={`nav-link ${isActive('/guide')}`} onClick={closeMobileMenu}>
              Restaurant App - Guide
            </Link>
          )}
          {isOwnerArea && (
            <a href="/#how-it-works" className="nav-link" onClick={closeMobileMenu}>
              Client App - How It Works
            </a>
          )}
          {isOwnerArea && (
            <Link to="/guide" className={`nav-link ${isActive('/guide')}`} onClick={closeMobileMenu}>
              Restaurant App - Guide
            </Link>
          )}
          {isOwnerArea && (
            <Link to="/contact" className={`nav-link ${isActive('/contact')}`} onClick={closeMobileMenu}>
              Contact
            </Link>
          )}
          {!isOwnerArea && <StoreButtons compact />}
          {isOwnerArea && isAuthenticated && (
            <>
              <button
                className="btn-login-icon"
                onClick={() => { closeMobileMenu(); navigate('/restaurant/settings'); }}
                aria-label="Settings"
                title="Settings"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="#4CAF50" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.14 12.94c.04-.3.06-.61.06-.94s-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.49.49 0 0 0-.59-.22l-2.39.96a7.02 7.02 0 0 0-1.62-.94l-.36-2.54A.484.484 0 0 0 14 2h-4a.484.484 0 0 0-.48.41l-.36 2.54a7.02 7.02 0 0 0-1.62.94l-2.39-.96a.48.48 0 0 0-.59.22L2.74 8.47a.47.47 0 0 0 .12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94L2.86 14.12a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.36 1.04.67 1.62.94l.36 2.54c.05.24.27.41.48.41h4c.24 0 .44-.17.47-.41l.36-2.54a7.02 7.02 0 0 0 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.47.47 0 0 0-.12-.61l-2.01-1.58zM12 15.6A3.6 3.6 0 1 1 12 8.4a3.6 3.6 0 0 1 0 7.2z"/>
                </svg>
              </button>
              <button
                className="btn-login-icon"
                onClick={handleLogout}
                aria-label="Logout"
                title="Logout"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </button>
            </>
          )}
          {isOwnerRoot && !isAuthenticated && (
            <button
              className="btn-login-icon"
              onClick={() => { closeMobileMenu(); navigate('/restaurant/login'); }}
              aria-label="Login"
              title="Login"
            >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                  <polyline points="10 17 15 12 10 7" />
                  <line x1="15" y1="12" x2="3" y2="12" />
                </svg>
            </button>
          )}
        </nav>

        <button
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
